import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import { Button } from 'components'
import styles from './index.module.css'
import Lib from 'library'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { influencerState } from './states'

const Influencer = () => {

	const App = useApp()
	const navigate = useNavigate()

	const [inflLankData, setInflLankData] = useState(0) // 구독수가 많은 인플루언서 리스트
	const influencer = useRecoilValue(influencerState)
	const [joinYn, setJoinYn] = useState() // 유저 가입여부

	const moreSliceN = 5; // 더보기 버튼 보여지는 리스트 개수
	const [influMoreBtn, setInfluMoreBtn] = useState(moreSliceN) // 추가된 더보기 버튼 
	const [influLength, setInfluLength] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => navigate("/home")} />,
			right: <i className="icon icon_question icon_question--dark" onClick={() => clickIntro()} />
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	const clickIntro = () => {
		navigate("/home/influencerIntro")
	}

	useEffect(() => {
		Lib.post(`/api/infl/lst/rank`, data => {
			//console.log('data : ' + JSON.stringify(data));
			setInfluLength(Math.ceil(data.length / moreSliceN));
			setInflLankData(data.slice(0, influMoreBtn))
		})
	}, [influMoreBtn])

	// 유저 가입여부
	useEffect(() => {
		setJoinYn(influencer ? influencer.joinYn : "N")
	}, [])

	// 구독하기
	const onSbsc = (item) => {
		if (joinYn === 'N') {
			App.showAlert({
				msg: `인플루언서에 참여해야<br />포트폴리오를 확인할 수 있습니다.<br />인플루언서에 참여하시겠습니까?`,
				closeBtn: true,
				confirm: true,
				onOk: () => navigate("/home/influencerProfile"),
				ok: "참여하기",
				cancel: "취소"
			})
		} else {
			Lib.post(`/api/infl/sbscr`, {
				sbscrMbId: item.mbId
			}, data => {
				console.log(data)
			})
		}

	}

	const influMoreButton = () => {
		setInfluMoreBtn(influMoreBtn + moreSliceN)
	}

	// 더보기 버튼
	const influMorebtnBox = () => {
		if (influLength > 1 && (influMoreBtn / moreSliceN) < influLength) {
			return (
				<div className="padding pb_50" onClick={influMoreButton}>
					<Button className="btn btn--big btn-more">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	return (
		<div className="page">
			<div className="shadow">
				<div className="visual-area">
					<p className="title">
						{`${App.user?.mbNm}님!`}<br /><strong>금융인플루언서</strong>에<br />참여해보세요!
					</p>
					<Link to="/home/influencerProfile" className="btn-link btn--gradient mt_20">참여하기<i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></Link>
					<div className={styles["influencer-object"]}></div>
				</div>
			</div>

			{inflLankData && inflLankData.length > 0 ? (
				<>
					<h3 className="padding pb_20">구독수가 많은 인플루언서</h3>
					<ul className={`${styles["influencer-list"]} list-bg`}>
						{inflLankData.map((item, index) => {
							let cssMedal = '';
							if (index === 0) cssMedal = 'icon_medal_gold'
							if (index === 1) cssMedal = 'icon_medal_silver'
							if (index === 2) cssMedal = 'icon_medal_bronze'
							return (
								<li key={index}>
									<div className="flex-align_center">
										<span className={styles.number}>{item.rank}</span>
										<div className="flex-align_center ml_20">
											<div className={styles["user"]}>
												<div className="img-box user-profile profile_50">
													<img src={"/images/profile/influencer_profile" + item.prflCd + ".svg"} alt="프로필 이미지" />
												</div>
												<i className={`icon ${cssMedal}`} />
											</div>
											<div className={`${styles.profile} ml_10`}>
												<p>{item.ncknm}</p>
												<span className="flex-align_center mt_5"><span className="text-blue">{item.sbscrCnt}명</span>이 구독중</span>
											</div>
										</div>
									</div>
									<span className={`${styles.choose}`} onClick={() => onSbsc(item)}>+ 구독하기</span>
								</li>
							)
						})}
					</ul>
					{/* 더보기 버튼 */}
					{influMorebtnBox()}
				</>
			) : (
				<>
					{/* 데이터 없을 때 */}
					<div className="center-cont py_80">
						<i className="icon_influencer_smile" />
						<p className="mt_15" style={{ fontSize: "1.6rem" }}>첫번째 인플루언서가<br />되어보세요!</p>
					</div>
				</>
			)}
		</div>
	)
}

export default Influencer
